import { render, staticRenderFns } from "./Kereses.vue?vue&type=template&id=33f281a6&"
import script from "./Kereses.vue?vue&type=script&lang=js&"
export * from "./Kereses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports